// Full screen: the browser's own, asked for on this computer (F, or the
// menu), and the room's screen without its chrome, which the phone asks
// for.

export default {
  // The deck's own frame fills the screen; the nav goes with the chrome.
  toggleFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen?.();
    } else {
      this.element.requestFullscreen?.();
    }
  },

  // Full screen asked for from the phone. A page may only make itself
  // full screen in answer to a click or a key on its own computer, so a
  // message from the phone is refused — and the deck's own chrome goes
  // instead: no nav, no exit, no cursor, the board as large as the window.
  // Leaving always works.
  setScreen(on) {
    this.element.classList.toggle("deck--full", on);
    if (on && !document.fullscreenElement) this.element.requestFullscreen?.()?.catch(() => {});
    if (!on && document.fullscreenElement) document.exitFullscreen?.()?.catch(() => {});
    this.announceScreen();
  },

  // The browser's own Esc leaves full screen; the chrome comes back with it.
  handleFullscreenChange() {
    if (!document.fullscreenElement) this.element.classList.remove("deck--full");
    this.announceScreen();
  },

  announceScreen() {
    if (!this.room) return;
    this.send({ screen: this.element.classList.contains("deck--full") || Boolean(document.fullscreenElement) });
  },

  // The phone's Full screen button, for the room's screen.
  remoteScreen() {
    this.send({ fullscreen: this.screenButtonTarget.getAttribute("aria-pressed") !== "true" });
  },
};
